import { Type } from "class-transformer";
import { IsDate, IsBoolean } from "class-validator";
import { AbstractJSONModel } from "./master-model";

export interface IDepartmentPost {
  id: number;
  name: string;
  institution_id: number;
  is_active: boolean;
}

export interface IDepartmentPut {
  id: number;
  name: string;
  is_active: boolean;
}

export interface IDepartment {
  id: number;
  name: string;
  institution_id: number;
  created_at: Date;
  updated_at: Date;
  is_active: boolean;
}

export class Department extends AbstractJSONModel implements IDepartment {
  public id = -1;
  public name = "";
  public institution_id = -1;
  @IsDate()
  @Type(() => Date)
  public created_at: Date = new Date();
  @IsDate()
  @Type(() => Date)
  public updated_at: Date = new Date();
  @IsBoolean()
  public is_active = true;

  public equals(other: IDepartment): boolean {
    return other.id === this.id;
  }

  public convertToPutObject(): IDepartmentPut {
    const d: IDepartmentPut = Object.assign({});
    d.id = this.id;
    d.name = this.name;
    d.is_active = this.is_active;
    return d;
  }
}

export interface IDepartmentEmployee {
  id: number;
  department_id: number;
  employee_id: number;
}

export class DepartmentEmployee extends AbstractJSONModel implements IDepartmentEmployee {
  public id = -1;
  public department_id = -1;
  public employee_id = -1;

  public equals(other: IDepartmentEmployee): boolean {
    return other.id === this.id;
  }
}
